export const hasNumberError = { hasNumber: true };

export function hasNumber(str: string) {
  return /\d/.test(str);
}
